import { cn } from '@c2fo/liquidity';
import { NavigationItem } from '../Navigation';

export interface NavigationItemContainerProps {
  item: NavigationItem;
  isDisabled: boolean;
  className?: string;
}

export const getContainerProps = ({ item, isDisabled, className }: NavigationItemContainerProps) => ({
  className: cn(
    'relative flex w-full items-center gap-4 overflow-hidden p-3 pl-4',
    {
      'cursor-default opacity-50': isDisabled,
    },
    className
  ),
  ...item.additionalAttributes,
  ...(item.intercomTarget && { 'data-intercom-target': item.intercomTarget }),
});

export const getAccessibilityProps = (isDisabled: boolean) => ({
  role: 'button' as const,
  tabIndex: isDisabled ? -1 : 0,
  'aria-disabled': isDisabled,
});
